<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" labelAlign="left"  :model="form" :rules="rules">
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="liveName" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>直播间名称<template slot="title">直播间名称</template></a-tooltip> </span>
            <a-input v-model="form.liveName" :maxLength="255" :placeholder="$t('请输入')+'直播间名称'"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item prop="theme"  :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>直播主题<template slot="title">直播主题</template></a-tooltip> </span>
            <a-input v-model="form.theme" :maxLength="255" :placeholder="$t('请输入')+'直播主题'"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item prop="intro"  :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>直播介绍<template slot="title">直播介绍</template></a-tooltip> </span>
            <a-input v-model="form.intro" :placeholder="$t('请输入')" type="textarea" allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item prop="nickName"  :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>直播用户昵称<template slot="title">直播用户昵称</template></a-tooltip> </span>
            <a-input v-model="form.nickName" :maxLength="255" :placeholder="$t('请输入')+'直播用户昵称'"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="avatar" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>直播用户头像<template slot="title">直播用户头像</template></a-tooltip> </span>
            <oss-upload-single :height="100" :width="100"  v-model="form.avatar" prefix="live" type="img"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="thumb" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>直播封面<template slot="title">直播封面</template></a-tooltip> </span>
            <oss-upload-single :height="100" :width="100"  v-model="form.thumb" prefix="live" type="img"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="categoryId" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>直播分类<template slot="title">直播分类</template></a-tooltip> </span>
            <a-select style="width: 100%" v-model="form.categoryId" placeholder="请选择直播分类">
              <a-select-option v-for="(item, index) in categoryList" :value="item.id" :key="index">
                {{ item.categoryName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="preOpenTime"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>预计开播时间<template slot="title">预计开播时间</template></a-tooltip> </span>
            <a-date-picker style="width: 100%" v-model="form.preOpenTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="needPayAmount"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>支付金额<template slot="title">支付金额</template></a-tooltip> </span>
            <a-input-number v-model="form.needPayAmount" :min="0" :step="0.01" style="width: 100%" :placeholder="$t('请输入')+'金额'" />
          </a-form-model-item>
        </a-col>

<!--        <a-col :span="12">
          <a-form-model-item prop="screenMode"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>屏幕模式<template slot="title">屏幕模式</template></a-tooltip> </span>
            <a-radio-group v-model="form.screenMode" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.LiveScreenModeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>-->
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="goodsList"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>选择商品<template slot="title">选择商品</template></a-tooltip> </span>
            <a-button type="dashed"  v-if="form.goodsList!=null && form.goodsList.length > 0" style="text-align: left; width: 100%" @click="openGoodsSelect" danger>
              <span style="color: dodgerblue">已选择{{form.goodsList.length}}件商品</span>
            </a-button>
            <a-button v-else plain type="primary" @click="openGoodsSelect">选择商品</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="actorList"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>选择参演人<template slot="title">选择参演人</template></a-tooltip> </span>
            <a-button type="dashed"  v-if="form.actorList!=null && form.actorList.length > 0" style="text-align: left; width: 100%" @click="openUserSelect" danger>
              <span style="color: dodgerblue">已选择{{form.actorList.length}}用户</span>
            </a-button>
            <a-button v-else plain type="primary" @click="openUserSelect">选择用户</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-if="form.actorList && form.actorList.length> 0">
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="userColumns"
          :data-source="form.actorList"
          :pagination="false"
          :bordered="tableBordered">
          <template slot="avatar" slot-scope="text, record">
            <oss-upload-single :height="50" :width="50"  v-model="record.avatar" prefix="live" type="img"/>
          </template>
          <div slot="nickName" slot-scope="text, record">
            <a-input v-model="record.nickName"   />
          </div>
          <span slot="sex" slot-scope="text, record">
          <!-- 重写自定义了个字典组件-->
          <custom-dict-tag :options="customDict.SexEnum" :value="record.sex"/>
        </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="handleDeleteUser(record.userId)" >
              <a-icon type="delete" />{{$t('删除')}}
            </a>
          </span>
        </a-table>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </a-form-model>
    <goods-checkbox-select ref="goodsSelect" @goodsSelect="handleGoodsSelected"></goods-checkbox-select>
    <checkbox-user-select-form ref="checkboxUserSelectForm" @userSelect="indexUserSelect"></checkbox-user-select-form>
  </a-drawer>
</template>

<script>
import {getCommunityLive, addCommunityLive, updateCommunityLive} from '@/api/community/live'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import GoodsCheckboxSelect from "@/views/goods/goods/select/GoodsCheckboxSelect.vue";
import checkboxUserSelectForm from "@/views/user/user/modules/CheckboxSelectForm.vue";
import {tableMixin} from "@/store/table-mixin";


export default {
  name: 'CreateForm',
  props: {
    categoryList:{
      require: true,
      type: Array
    }
  },
  mixins: [tableMixin],
  components: {
    checkboxUserSelectForm,
    GoodsCheckboxSelect,
    OssUploadSingle,
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      formTitle: '',
      loading: false,
      // 表单参数
      form: {
        id: null,

        liveType: 2,
        imGroupId: null,
        userId: null,
        merchantId: null,
        liveName: null,
        nickName: null,
        thumb: null,
        theme: null,
        intro: null,
        preOpenTime: null,
        needPayAmount: 0,
        screenMode: 2,
        goodsList: [],
        actorList: [],
        pushUrl: null,
        pullUrl: null,
        status: 0,
        categoryId: null,
        liveCityId: null,
        liveAddress: null
      },
      userColumns: [
        {
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: this.$t('邮箱'),
          dataIndex: 'email',
          align: 'center'
        },
        {
          title: this.$t('昵称'),
          dataIndex: 'nickName',
          scopedSlots: { customRender: 'nickName' },
          align: 'center'
        },
        {
          title: this.$t('头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center'
        },
        {
          title: this.$t('性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        liveName: [{required: true, message: '直播间名称' + this.$t('不能为空'), trigger: 'blur'}],
        theme: [{required: true, message: '直播主题' + this.$t('不能为空'), trigger: 'blur'}],
        nickName: [{required: true, message: '直播用户昵称' + this.$t('不能为空'), trigger: 'blur'}],
        avatar: [{required: true, message: '直播用户头像' + this.$t('不能为空'), trigger: 'change'}],
        thumb: [{required: true, message: '直播封面' + this.$t('不能为空'), trigger: 'change'}],
        categoryId: [{required: true, message: '直播分类' + this.$t('不能为空'), trigger: 'change'}],
        preOpenTime: [{required: true, message: '预计开播时间' + this.$t('不能为空'), trigger: 'change'}],
        screenMode: [{required: true, message: '屏幕模式' + this.$t('不能为空'), trigger: 'change'}],

      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        liveType: 2,
        imGroupId: null,
        userId: null,
        merchantId: null,
        liveName: null,
        nickName: null,
        thumb: null,
        theme: null,
        intro: null,
        preOpenTime: null,
        needPayAmount: 0,
        screenMode: 2,
        goodsList: [],
        actorList: [],
        pushUrl: null,
        pullUrl: null,
        status: 0,
        categoryId: null,
        liveCityId: null,
        liveAddress: null
      }

    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

    // 关闭当前标签页
    openUserSelect() {
      this.$refs.checkboxUserSelectForm.openUser()
    },
    indexUserSelect(record) {
      if (!record) {
        return
      }
      record.forEach(e => {
        e.userId = e.id
      });
      const cloneData = JSON.parse(JSON.stringify(record))
      // 去重
      cloneData.forEach(e => {
        if (!this.form.actorList.find(g => g.userId === e.id)) {
          this.form.actorList.push(e)
        }
      })
    },

    handleDeleteUser(id) {
      let filter = this.form.actorList.filter(e => e.userId !== id);
      this.form.actorList =filter;
    },

    handleDeleteAllUser() {
      this.form.actorList =[];
    },

    openGoodsSelect() {
      //this.form.merchantList id 数组
      let merchantIdList = []
      this.$refs.goodsSelect.openGoods(this.form.goodsList, merchantIdList,[20,21]);
    },
    handleGoodsSelected(list) {
      console.log('商品选择了:',list)
      this.form.goodsList = list
    },

    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityLive({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityLive(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityLive(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.ant-card-body {
  padding: 5px;
}
</style>